<!-- Responsibility: Display a critical system failure screen with recovery options.
Scope: Self-managing error presentation; listens to system:fatalError. -->
<error-view class="menu-overlay" hidden={ !state.visible }>
  <div class="error-splash" if={ state.visible }>
    <div class="error-box">
      <header>
        <span class="error-icon">⚠</span>
        <h2>SYSTEM CRITICAL FAILURE</h2>
      </header>
      
      <p class="error-intro">The OS encountered an unrecoverable runtime error. The current operation was aborted to prevent state corruption.</p>
      
      <div class="error-details" if={ state.error }>
        <pre>{ state.error }</pre>
      </div>

      <div class="error-actions">
        <button class="action-btn primary" onclick={ onRecover }>RELOAD & RECOVER</button>
        <button class="action-btn" onclick={ onBackToHub }>RETURN TO LOBBY</button>
      </div>
    </div>
  </div>

  <script>
    import { dispatcher, navigateState } from '../../app-states.js'
    import { TOPICS } from "@anyquest/shared-core"

    export default {
      state: {
        visible: false,
        error: null,
      },

      onMounted() {
        this.handle = dispatcher.on(TOPICS.system.fatalError, (_o, d) => {
          this.update({
            visible: true,
            error: d?.message || 'Unknown runtime error'
          })
        })
      },

      onUnmounted() {
        if (this.handle) dispatcher.off(this.handle)
      },

      onRecover() {
        window.location.reload()
      },

      onBackToHub() {
        this.update({ visible: false, error: null })
        navigateState('hub')
      }
    }
  </script>

  <style>
    :host {
      position: fixed;
      inset: 0;
      z-index: var(--z-index-max, 9999);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: var(--space-lg);
      background: var(--bg);
    }

    .error-splash {
      width: 100%;
      max-width: 40rem;
      animation: error-fade-in 0.4s ease-out;
    }

    .error-box {
      background: color-mix(in srgb, var(--surface) 80%, black);
      border: 1px solid var(--danger);
      border-radius: var(--space-md);
      padding: var(--space-lg);
      box-shadow: 0 2rem 4rem rgba(0, 0, 0, 0.6);
      display: flex;
      flex-direction: column;
      gap: var(--space-lg);
    }

    .error-box header {
      display: flex;
      align-items: center;
      gap: var(--space-md);
      color: var(--danger);
    }

    .error-icon {
      font-size: 2.5rem;
    }

    .error-box h2 {
      margin: 0;
      font-size: 1.5rem;
      letter-spacing: 0.1em;
    }

    .error-intro {
      color: var(--text-muted);
      line-height: 1.5;
      margin: 0;
    }

    .error-details {
      background: rgba(0, 0, 0, 0.4);
      padding: var(--space-md);
      border-radius: var(--space-xs);
      border: 1px solid rgba(255, 255, 255, 0.05);
    }

    .error-details pre {
      margin: 0;
      white-space: pre-wrap;
      word-break: break-all;
      font-size: 0.85rem;
      color: var(--danger);
      font-family: var(--font-mono);
    }

    .error-actions {
      display: flex;
      gap: var(--space-md);
      justify-content: center;
      margin-top: var(--space-sm);
    }

    @media (max-width: 30rem) {
      .error-actions { flex-direction: column; }
    }
  </style>
</error-view>
